export default "__VITE_ASSET__CrAdFt3y__"